<template>
  <rest-list-action
    icon="el-icon-video-pause"
    :title="$t('RestList_Action_Stop')"
    :click="click"
  />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'RestListActionStop',
  components: { RestListAction },
  inject: ['restList'],

  props: {
    endpoint: {
      type: Object,
      required: true
    },
    isWorkflow: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    click() {
      this.$msgbox({
        title: this.$t('RestList_StopTitle'),
        message: this.isWorkflow
          ? this.$t('RestList_StopWorkflowPrompt')
          : this.$t('RestList_StopPrompt', { label: this.name }),
        showCancelButton: true,
        confirmButtonText: this.$t('RestList_StopConfirmButton'),
        cancelButtonText: this.$t('RestList_StopCancelButton'),
        dangerouslyUseHTMLString: this.isWorkflow,
        center: true
      }).then(() => {
        this.restList.loading = true
        RestApi(this.endpoint)
          .then(() => {
            this.$message({
              message: this.$t('RestList_StopSuccessMessage'),
              type: 'success'
            })
            EventBus.$emit('refreshStopAll')
            this.restList.refresh()
            this.restList.loading = false
          })
          .catch(error => {
            this.restList.loading = false
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/components/RestListActionStop.vue